import React, { useState, useEffect } from "react";
import PropTypes from "prop-types"; // Import PropTypes

import AuthServices from "../../services/AuthServices";

const Modal = ({ isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button
          aria-label="Close modal"
          onClick={onClose}
          style={styles.closeButton}
        >
          ×
        </button>
        <h2 style={styles.heading}>WOULD YOU LIKE</h2>
        <div style={styles.discountTextContainer}>
          <p style={styles.discount}>10%</p>
          <p style={styles.off}>OFF</p>
        </div>
        <p style={styles.subHeading}>Your First Purchase?</p>
        <div style={styles.lineContainer}>
          <p style={styles.line}></p>
          <p style={styles.arrow}>^</p>
          <p style={styles.line}></p>
        </div>
        <input
          type="text"
          placeholder="Enter your email"
          style={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          style={styles.subscribeButton}
          onClick={() => onSubmit(email)}
        >
          Subscribe Now
        </button>
      </div>
    </div>
  );
};


// Adding PropTypes validation
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired, 
  onSubmit: PropTypes.func.isRequired, 
};

const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenModal");
    console.log("hasSeenModal", hasSeenModal);
  
    if (hasSeenModal === null) {
      const timer = setTimeout(() => {
        setIsModalOpen(true);
      }, 10000);
  
      return () => clearTimeout(timer);
    }
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const submitModal = async (email) => {
    setIsModalOpen(false);
    try{
      const data = {email};
      const response = await AuthServices.saveDiscountList(data);
    } catch(error) {

    }
    
    localStorage.setItem("hasSeenModal", true);  // Mark as seen
  };

  return <Modal isOpen={isModalOpen} onClose={closeModal} onSubmit={submitModal} />;
};

// Styles for modal and overlay
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    animation: 'fadeIn 0.3s ease forwards',
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
    background: "transparent",
    border: "none",
    fontSize: 36,
    fontWeight: "bold",
    cursor: "pointer",
    color: "#333",
    transition: "color 0.3s ease",
    padding: 0,
    lineHeight: 1,
    width: "auto"
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '24px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    padding: '32px 40px',
    maxWidth: '420px',
    width: '90%',
    textAlign: 'center',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    position: 'relative',
    animation: 'slideUp 0.3s ease forwards',
  },
  heading: {
    fontSize: '1.8rem',
    fontWeight: '700',
    letterSpacing: '4px',
    marginBottom: '24px',
    color: '#333',
    marginTop: "16px",
    textTransform: 'uppercase',
  },
  discountTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '6px',
    marginBottom: '8px',
  },
  discount: {
    fontSize: '4.2rem',
    fontWeight: '900',
    color: '#ff4a4a',
    lineHeight: 1,
  },
  off: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#ff4a4a',
    opacity: 0.7,
    marginBottom: '8px',
  },
  subHeading: {
    fontSize: '1.2rem',
    fontWeight: '400',
    color: '#555',
    marginBottom: '24px',
  },
  lineContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '28px',
  },
  line: {
    flex: 1,
    height: '2px',
    backgroundColor: '#ddd',
    borderRadius: '2px',
  },
  arrow: {
    fontSize: '1.6rem',
    color: '#ff4a4a',
    transform: 'rotate(45deg)',
    userSelect: 'none',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '1rem',
    borderRadius: '12px',
    border: '1.5px solid #ddd',
    marginBottom: '24px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  inputFocus: {
    borderColor: '#ff4a4a',
    boxShadow: '0 0 6px rgba(255,74,74,0.4)',
  },
  subscribeButton: {
    width: '100%',
    padding: '14px 0',
    fontSize: '1.1rem',
    fontWeight: '700',
    backgroundColor: '#ff4a4a',
    color: '#fff',
    border: 'none',
    borderRadius: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    marginBottom: '24px',
  },
  subscribeButtonHover: {
    backgroundColor: '#e04343',
    transform: 'scale(1.05)',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    gap: '20px',
  },
  buttonYes: {
    flex: 1,
    padding: '12px 0',
    fontSize: '1rem',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#28a745',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  buttonYesHover: {
    backgroundColor: '#218838',
  },
  buttonNo: {
    flex: 1,
    padding: '12px 0',
    fontSize: '1rem',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#dc3545',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  buttonNoHover: {
    backgroundColor: '#c82333',
  },
};

// Add hover effects for buttons
//   styles.buttonYes:hover = {
//     backgroundColor: '#218838', // Darker green on hover for "Yes"
//   };

//   styles.buttonNo:hover = {
//     backgroundColor: '#c82333', // Darker red on hover for "No"
//   };

export default App;
